// Baralho, força das cartas, manilha e lugares na mesa. Origem: TrucoEngine do protótipo.
import type { Card, Gesture, HandValue, Level, Rank, Seat, Suit, Team } from './types.ts';

// Sinais fixos, iguais em toda mão (CLAUDE.md, Regras do jogo). Manilhas pelo naipe; 3, 2 e A pelo posto.
export interface Sinal { gesture: Gesture; carta: string; gesto: string; emoji: string; naipe?: Suit; posto?: Rank }
export const SINAIS: readonly Sinal[] = [
  { gesture: 'piscar', carta: 'Zap', gesto: 'Piscar', emoji: '😉', naipe: 'c' },
  { gesture: 'sobrancelha', carta: 'Copas', gesto: 'Sobrancelha levantada', emoji: '🤨', naipe: 'h' },
  { gesture: 'bochecha', carta: 'Espadas', gesto: 'Bochecha', emoji: '😗', naipe: 's' },
  { gesture: 'lingua', carta: 'Ouros', gesto: 'Língua para fora', emoji: '😛', naipe: 'd' },
  { gesture: 'tres', carta: '3', gesto: 'Número 3', emoji: '3️⃣', posto: '3' },
  { gesture: 'dois', carta: '2', gesto: 'Número 2', emoji: '2️⃣', posto: '2' },
  { gesture: 'as', carta: 'A', gesto: 'Letra A', emoji: '🅰️', posto: 'A' },
  { gesture: 'nada', carta: 'Nada', gesto: 'Negativo', emoji: '👎' },
];

export const ORDER: readonly Rank[] = ['4', '5', '6', '7', 'Q', 'J', 'K', 'A', '2', '3'];
export const SUITS: readonly Suit[] = ['c', 'h', 's', 'd'];
export const MANILHA_SUIT: Readonly<Record<Suit, number>> = { d: 0, s: 1, h: 2, c: 3 }; // ouros < espadas < copas < paus (Zap)
export const LADDER: readonly HandValue[] = [1, 3, 6, 9, 12];
export const GESTURES: readonly Gesture[] = SINAIS.map((s) => s.gesture);
export function sinalDe(g: Gesture): Sinal { return SINAIS.find((s) => s.gesture === g)!; }
export const NAMES: readonly string[] = ['Você', 'Nando', 'Bia', 'Zeca', 'Rafa', 'Léo'];
export const SEATS: readonly Seat[] = [0, 1, 2, 3, 4, 5];

export function team(seat: Seat): Team { return (seat % 2) as Team; } // 0 = Nós (0,2,4), 1 = Eles (1,3,5)
export function next(seat: Seat): Seat { return ((seat + 5) % 6) as Seat; } // sentido anti-horário: para a direita de quem joga
export function partners(seat: Seat): Seat[] { return SEATS.filter((s) => s !== seat && team(s) === team(seat)); }
export function rankOf(id: Card): Rank { return id.slice(0, -1) as Rank; }
export function suitOf(id: Card): Suit { return id.slice(-1) as Suit; }
export function manilhaRankFor(vira: Card): Rank { return ORDER[(ORDER.indexOf(rankOf(vira)) + 1) % ORDER.length]!; }
export function strength(id: Card, manRank: Rank): number {
  const r = rankOf(id);
  return r === manRank ? 100 + MANILHA_SUIT[suitOf(id)] : ORDER.indexOf(r);
}
export function nextLevel(v: HandValue): Level | null {
  const i = LADDER.indexOf(v);
  return i >= 0 && i < LADDER.length - 1 ? (LADDER[i + 1] as Level) : null;
}
export function deck(): Card[] {
  const d: Card[] = [];
  for (const r of ORDER) for (const s of SUITS) d.push(r + s);
  return d;
}
